/* @flow */
/* Do not edit - Generated by iconify. See README.md for more details. */
/* eslint-disable max-len */
import type { ElementConfig as ReactElementConfig } from "react"

import BaseIcon from "./BaseIcon";

export default class SvgIconSend extends BaseIcon {
    static defaultProps: ReactElementConfig<typeof BaseIcon> = {
        iconClass: "SendIcon",
    }

    svgContent: string = `
        <svg class='${this.classNames}' width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.674837 15.5L18.1665 8L0.674837 0.5L0.666504 6.33333L13.1665 8L0.666504 9.66667L0.674837 15.5Z" fill="white"/></svg>
        `;
}
